// src/components/admin/settings/FooterSettings.jsx
import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import './SettingsPages.css';

const FooterSettings = () => {
  const [settings, setSettings] = useState({
    footer_text: '© 2024 ShopDemo. All rights reserved.'
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/public/get-settings.php');
      const data = await response.json();
      if (data.success && data.settings) {
        setSettings(prev => ({ ...prev, ...data.settings }));
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setSettings({ ...settings, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const response = await fetch('https://demo-site.storii.com.pk/demo-api/admin/update-settings-simple.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(settings)
      });
      const data = await response.json();
      if (data.success) {
        toast.success('Footer saved!');
      } else {
        toast.error('Failed to save');
      }
    } catch (error) {
      toast.error('Connection error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="loader">Loading footer...</div>;

  return (
    <div className="settings-page">
      <h2>Footer Settings</h2>
      <p className="section-description">Customize your store's footer text</p>
      
      <form onSubmit={handleSubmit} className="settings-form">
        <div className="form-group">
          <label>Footer Text</label>
          <input type="text" name="footer_text" value={settings.footer_text} onChange={handleChange} />
        </div>
        <button type="submit" disabled={saving} className="save-btn">{saving ? 'Saving...' : 'Save Footer'}</button>
      </form>
    </div>
  );
};

export default FooterSettings;